// Hook: manage onboarding bubble state (SPEC 001 T148)
import { useCallback, useEffect, useState } from "react";
import {
  dismissOnboarding,
  getOnboarding,
} from "../../../services/copilot/copilotApi";

export function useCopilotOnboarding() {
  const [showBubble, setShowBubble] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getOnboarding()
      .then((data) => {
        if (!cancelled) setShowBubble(data.showIntroBubble);
      })
      .catch(() => {
        // 501 in Phase 2 — swallow gracefully
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const dismiss = useCallback(async () => {
    setShowBubble(false);
    try {
      await dismissOnboarding();
    } catch {
      // best-effort
    }
  }, []);

  return { showBubble, loading, dismiss };
}
